export default __webpack_public_path__ + "static/media/shrink_ray.517f7de7.svg";